import React, { useState } from 'react';
import { mockGadgetSubmissions } from '../../data/mockData';
import { Printer, Download, ChevronLeft, ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { GadgetSubmission } from '../../types';
export const ProjnapanPreview: React.FC = () => {
  const approvedSubmissions = mockGadgetSubmissions.filter(g => g.status === 'approved' || g.status === 'published');
  const [selectedSub, setSelectedSub] = useState<GadgetSubmission | null>(approvedSubmissions.length > 0 ? approvedSubmissions[0] : null);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const handlePrint = () => {
    window.print();
  };
  const handleDownload = (format: 'pdf' | 'docx') => {
    setShowDownloadMenu(false);
    // Simulate download
    const fileName = `প্রজ্ঞাপন_${selectedSub?.id || 'document'}.${format}`;
    alert(`${format.toUpperCase()} ফরম্যাটে ডাউনলোড হচ্ছে: ${fileName}`);
  };
  if (!selectedSub) {
    return <div className="max-w-4xl mx-auto text-center py-20" data-id="element-786">
        <h2 className="text-xl font-semibold text-slate-700" data-id="element-787">
          কোন অনুমোদিত গেজেট নেই
        </h2>
        <p className="text-slate-500" data-id="element-788">
          প্রজ্ঞাপন তৈরি করার জন্য প্রথমে গেজেট অনুমোদন করুন।
        </p>
      </div>;
  }
  return <div className="max-w-5xl mx-auto pb-12" data-id="element-789">
      {/* Non-printable controls */}
      <div className="print:hidden mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-790">
        <div className="flex items-center" data-id="element-791">
          <Link to="/gadget/ds-submissions" className="text-slate-500 hover:text-slate-800 mr-4" data-id="element-792">
            <ChevronLeft size={24} data-id="element-793" />
          </Link>
          <div data-id="element-794">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-795">গেজেট প্রিভিউ</h1>
            <p className="text-slate-500" data-id="element-796">
              চূড়ান্ত সরকারি গেজেট প্রিন্ট বা সংরক্ষণ করুন
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-3" data-id="element-797">
          <select className="input-field text-sm w-64" value={selectedSub.id} onChange={e => {
          const sub = approvedSubmissions.find(s => s.id === e.target.value);
          if (sub) setSelectedSub(sub);
        }} data-id="element-798">
            {approvedSubmissions.map(sub => <option key={sub.id} value={sub.id} data-id="element-799">
                {sub.id} - {sub.district} ({sub.moujaDetails.length} মৌজা)
              </option>)}
          </select>
          <div className="relative" data-id="element-800">
            <button onClick={() => setShowDownloadMenu(!showDownloadMenu)} className="btn-secondary flex items-center" data-id="element-801">
              <Download size={18} className="mr-2" data-id="element-802" /> ডাউনলোড
              <ChevronDown size={16} className="ml-1" data-id="element-803" />
            </button>
            {showDownloadMenu && <>
                <div className="fixed inset-0 z-10" onClick={() => setShowDownloadMenu(false)} data-id="element-804" />
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-slate-200 z-20" data-id="element-805">
                  <button onClick={() => handleDownload('pdf')} className="w-full text-left px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 flex items-center" data-id="element-806">
                    <Download size={16} className="mr-2 text-red-500" data-id="element-807" />
                    PDF ডাউনলোড
                  </button>
                  <button onClick={() => handleDownload('docx')} className="w-full text-left px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 flex items-center border-t border-slate-100" data-id="element-808">
                    <Download size={16} className="mr-2 text-blue-500" data-id="element-809" />
                    DOCX ডাউনলোড
                  </button>
                </div>
              </>}
          </div>
          <button onClick={handlePrint} className="btn-primary flex items-center" data-id="element-810">
            <Printer size={18} className="mr-2" data-id="element-811" /> প্রিন্ট করুন
          </button>
        </div>
      </div>

      {/* Printable Document Container */}
      <div className="bg-white shadow-2xl mx-auto print:shadow-none print:m-0 print:w-full" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm'
    }} data-id="element-812">
        {/* Header */}
        <div className="text-center mb-8 font-bengali" data-id="element-813">
          <p className="text-base" data-id="element-814">গণপ্রজাতন্ত্রী বাংলাদেশ সরকার</p>
          <p className="text-base" data-id="element-815">ভূমি মন্ত্রণালয়</p>
          <p className="text-base" data-id="element-816">জরিপ-২ শাখা</p>
          <p className="text-base" data-id="element-817">বাংলাদেশ সচিবালয়, ঢাকা</p>
          <p className="text-base font-serif" data-id="element-818">www.minland.gov.bd</p>
        </div>

        {/* Reference & Date */}
        <div className="flex justify-between items-end mb-8 font-bengali text-sm" data-id="element-819">
          <div data-id="element-820">
            <p data-id="element-821">
              নম্বর: {selectedSub.smarakNo || '৩১.০০.০০০০.০৮৯.৩৩.০০১.২৫.৩৭'}
            </p>
          </div>
          <div className="text-right" data-id="element-822">
            <p data-id="element-823">১৯ মাঘ ১৪৩১ বঙ্গাব্দ</p>
            <div className="flex items-center justify-end" data-id="element-824">
              <span className="mr-2" data-id="element-825">তারিখ:</span>
              <span data-id="element-826">০২ ফেব্রুয়ারি ২০২৫ খ্রিস্টাব্দ</span>
            </div>
          </div>
        </div>

        {/* Title */}
        <div className="text-center mb-6 font-bengali" data-id="element-827">
          <h2 className="text-lg font-bold underline underline-offset-4" data-id="element-828">
            প্রজ্ঞাপন
          </h2>
        </div>

        {/* Legal Text */}
        <div className="mb-6 font-bengali text-justify leading-relaxed text-sm" data-id="element-829">
          <p data-id="element-830">
            The State Acquisition and Tenancy Act, 1950 (Act XXVIII of 1951) এর
            144(7) ধারা এবং Tenancy Rules, 1955 এর 34(2) বিধি অনুযায়ী
            গণপ্রজাতন্ত্রী বাংলাদেশ সরকার কর্তৃক এই মর্মে ঘোষণা করা যাচ্ছে যে,
            নিম্নবর্ণিত মৌজাসমূহের খতিয়ানসমূহ চূড়ান্তভাবে প্রকাশ করা হলোঃ
          </p>
        </div>

        {/* Table */}
        <div className="mb-12" data-id="element-831">
          <table className="w-full border-collapse border border-black text-sm font-bengali text-center" data-id="element-832">
            <thead data-id="element-833">
              <tr data-id="element-834">
                <th className="border border-black p-2 font-normal" data-id="element-835">
                  ক্রমিক নং
                </th>
                <th className="border border-black p-2 font-normal" data-id="element-836">
                  মৌজার নাম
                </th>
                <th className="border border-black p-2 font-normal" data-id="element-837">
                  জে. এল. নম্বর
                </th>
                <th className="border border-black p-2 font-normal" data-id="element-838">শুরু নং</th>
                <th className="border border-black p-2 font-normal" data-id="element-839">শেষ নং</th>
                <th className="border border-black p-2 font-normal" data-id="element-840">
                  খতিয়ান সংখ্যা
                </th>
                <th className="border border-black p-2 font-normal" data-id="element-841">
                  শীট সংখ্যা
                </th>
                <th className="border border-black p-2 font-normal" data-id="element-842">
                  উপজেলার নাম
                </th>
                <th className="border border-black p-2 font-normal" data-id="element-843">
                  জেলার নাম
                </th>
                <th className="border border-black p-2 font-normal" data-id="element-844">মন্তব্য</th>
              </tr>
            </thead>
            <tbody data-id="element-845">
              {selectedSub.moujaDetails.map((row, index) => {
              const bnIndex = (index + 1).toString().replace(/[0-9]/g, w => String.fromCharCode(w.charCodeAt(0) + 2486));
              const displayIndex = bnIndex.length === 1 ? `০${bnIndex}` : bnIndex;
              return <tr key={index} data-id="element-846">
                    <td className="border border-black p-2" data-id="element-847">{displayIndex}</td>
                    <td className="border border-black p-2" data-id="element-848">{row.mouja}</td>
                    <td className="border border-black p-2" data-id="element-849">{row.jlNumber}</td>
                    <td className="border border-black p-2" data-id="element-850">
                      {row.khatianStartNo || '—'}
                    </td>
                    <td className="border border-black p-2" data-id="element-851">
                      {row.khatianEndNo || '—'}
                    </td>
                    <td className="border border-black p-2" data-id="element-852">
                      {row.totalKhatian}
                    </td>
                    <td className="border border-black p-2" data-id="element-853">
                      {row.totalSheet}
                    </td>
                    <td className="border border-black p-2" data-id="element-854">{row.upazila}</td>
                    <td className="border border-black p-2" data-id="element-855">{row.district}</td>
                    <td className="border border-black p-2" data-id="element-856">
                      {row.remarks || '—'}
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>

        {/* Signature 1 */}
        <div className="flex justify-end mb-12 font-bengali text-sm text-center" data-id="element-857">
          <div data-id="element-858">
            <p className="mb-12" data-id="element-859">রাষ্ট্রপতির আদেশক্রমে,</p>
            <div className="border-b border-black w-40 mx-auto mb-2" data-id="element-860"></div>
            <p data-id="element-861">০২-০২-২০২৫</p>
            <p data-id="element-862">&nbsp;</p>
            <p data-id="element-863">উপসচিব</p>
            <p data-id="element-864">০২৯৫৪০৯১৯</p>
            <p className="font-serif" data-id="element-865">survey2@minland.gov.bd</p>
          </div>
        </div>

        {/* Distribution List */}
        <div className="font-bengali text-sm" data-id="element-866">
          <div className="flex justify-between items-end mb-4" data-id="element-867">
            <div data-id="element-868">
              <p data-id="element-869">
                নম্বর: {selectedSub.smarakNo || '৩১.০০.০০০০.০৮৯.৩৩.০০১.২৫.৩৭'}/১
                (৭)
              </p>
            </div>
            <div className="text-right" data-id="element-870">
              <p data-id="element-871">১৯ মাঘ ১৪৩১ বঙ্গাব্দ</p>
              <div className="flex items-center justify-end" data-id="element-872">
                <span className="mr-2" data-id="element-873">তারিখ:</span>
                <span data-id="element-874">০২ ফেব্রুয়ারি ২০২৫ খ্রিস্টাব্দ</span>
              </div>
            </div>
          </div>

          <p className="mb-2" data-id="element-875">
            অবগতি/অবগতি ও প্রয়োজনীয় ব্যবস্থা গ্রহণের জন্য অনুলিপি প্রেরণ করা
            হলো (জ্যেষ্ঠতার ক্রমানুসারে নয়):
          </p>
          <ol className="list-none space-y-1 ml-2" data-id="element-876">
            <li data-id="element-877">
              ১। মহাপরিচালক (গ্রেড-১), মহাপরিচালক-এর দপ্তর, ভূমি রেকর্ড ও জরিপ
              অধিদপ্তর।
            </li>
            <li data-id="element-878">
              ২। বিভাগীয় কমিশনার, বিভাগীয় কমিশনারের কার্যালয়, বিভাগীয়
              কমিশনারের কার্যালয়, {selectedSub.district}।
            </li>
            <li data-id="element-879">
              ৩। জেলা প্রশাসক, জেলা প্রশাসকের কার্যালয়, জেলা প্রশাসকের
              কার্যালয়, {selectedSub.district}।
            </li>
            <li data-id="element-880">
              ৪। উপ পরিচালক, উপপরিচালকের দপ্তর, বাংলাদেশ ফরম ও প্রকাশনা অফিস।
            </li>
            <li data-id="element-881">
              ৫। জোনাল সেটেলমেন্ট অফিসার, জোনাল সেটেলমেন্ট অফিসার-এর দপ্তর,
              জোনাল সেটেলমেন্ট অফিস, {selectedSub.district}।
            </li>
            <li data-id="element-882">
              ৬। সিস্টেম এনালিস্ট, সিকিউরিটি, অডিট ও কোয়ালিটি কন্ট্রোল
              (এসএকিউ), ভূমি মন্ত্রণালয়।
            </li>
            <li data-id="element-883">৭। অফিস / মাস্টার কপি।</li>
          </ol>
        </div>

        {/* Footer Signature & QR */}
        <div className="flex justify-between items-end mt-12 font-bengali text-sm" data-id="element-884">
          <div className="w-20 h-20 bg-slate-200 flex items-center justify-center border border-slate-300" data-id="element-885">
            <span className="text-slate-400 font-bold" data-id="element-886">QR</span>
          </div>
          <div className="text-center" data-id="element-887">
            <div className="border-b border-black w-40 mx-auto mb-2" data-id="element-888"></div>
            <p data-id="element-889">০২-০২-২০২৫</p>
            <p data-id="element-890">&nbsp;</p>
            <p data-id="element-891">উপসচিব</p>
          </div>
        </div>
      </div>
    </div>;
};